;(function () {
  'use strict'

  angular.module('contrast.license').factory('LicenseService', LicenseService)

  function LicenseService($uibModal, $rootScope, ServiceUtils, LicenseFactory) {
    'ngInject'

    var service = {
      getProtectionBreakdown: getProtectionBreakdown,
      getAssessmentBreakdown: getAssessmentBreakdown,
      applyAssessLicense: applyAssessLicense,
      noAvailableLicenses: noAvailableLicenses
    }

    return service

    function getProtectionBreakdown() {
      return LicenseFactory.getProtectionBreakdown()
        .then(ServiceUtils.handleResolve('data.breakdown'))
        .catch(ServiceUtils.handleError)
    }

    function getAssessmentBreakdown() {
      return LicenseFactory.getAssessmentBreakdown()
        .then(ServiceUtils.handleResolve('data.breakdown'))
        .catch(ServiceUtils.handleError)
    }

    function applyAssessLicense(app, breakdown) {
      return $uibModal
        .open({
          templateUrl: 'views/applications/modal_license.html',
          controller: 'AppLicenseModalInstanceCtrl',
          resolve: {
            app: function () {
              return app
            },
            licenses: function () {
              return breakdown
            }
          }
        })
        .result.then(function () {
          $rootScope.$broadcast('roles:updated')
          $rootScope.$broadcast('app.licensed')
        })
    }

    function noAvailableLicenses() {
      return $uibModal.open({
        templateUrl: 'views/applications/modal_upgrade_license.html',
        controller: 'AppUpgradeLicenseModalInstanceCtrl'
      }).result
    }
  }
})()
